import { PERIODICITY_TYPE_LABEL_MAP } from './periodicity-type-label-map';
import type { PeriodicityTypes } from './periodicity-types';

export const PERIODICITY_TYPE_OPTIONS = Object.entries(PERIODICITY_TYPE_LABEL_MAP).map(
  ([value, label]) => ({
    value: Number(value) as PeriodicityTypes,
    label,
  }),
);
